import styled from "styled-components";
import {
  Colors,
  GrayColors,
  IconColorNames,
  TextColorNames,
} from "@smartsuite/types";
import { TextSizes } from "@smartsuite/react-ui/lib";
import type { PartialButtonStylesType } from "@smartsuite/react-ui/lib/components/buttons/Button/Button.types";

export const buttonDetailsStyle: PartialButtonStylesType = {
  background: "white",
  textColor: IconColorNames.dark,
  height: 26,
  sidePadding: 6,
  textSize: TextSizes.S,
  borderRadius: 6,
  borderWidth: 1,
  borderColor: GrayColors["G-1-5"],
  textWeight: "regular",
  iconLeftIndent: 7,
  iconRightIndent: 0,
  iconColor: GrayColors["G-8"],
};

export const ModalContent = styled.div`
  overflow: scroll;
  padding: 10px 0px 10px 0px;
  max-height: 30vh;
  min-height: 15vh;
`;

export const Link = styled.a`
  display: flex;
  color: ${TextColorNames.primary};
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  text-decoration: none;
  margin: 10px 25px 10px 25px;
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #e9e9e9;
  &:hover {
    text-decoration: underline;
  }
`;

export const Container = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  margin-inline: auto;
  width: fit-content;

  .modal {
    padding-top: 16px;

    border-radius: 4px;
    background-color: ${GrayColors["G-0"]};
  }

  .modal-header {
    padding: 0 30px 16px 25px;
  }
`;

export const Close = styled.div`
  position: absolute;
  top: -5px;
  right: 20px;
  display: flex;

  color: ${GrayColors["G-5"]};
  background-color: #f3f3f4;
  border-radius: 20%;
  align-items: center;
  justify-content: center;
  padding: 6px 6px 6px 6px;

  cursor: pointer;

  &:hover {
    color: ${GrayColors["G-7"]};
  }
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
`;

export const IconsWrap = styled.div`
  margin-left: auto;
  display: flex;

  .trash-tooltip {
    display: none;
    line-height: 0;
    &:hover {
      color: ${GrayColors["G-5"]};
    }
  }
`;

export const SelectFieldContainer = styled.div<{ $hasError?: boolean }>`
  margin-bottom: 15px;
  position: relative;

  .react-input-group.is-error {
    border-color: ${Colors.bRed} !important;
  }

  ${({ $hasError }) =>
    $hasError
      ? `
    .react-input-group {
      border-color: ${Colors.bRed} !important;
    }
  `
      : ""}
`;

export const SelectItem = styled.div`
  height: 32px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  color: ${TextColorNames.tertiary};
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;

  // justify-content: center;
  // align-items: center;

  &:hover,
  &.active {
    background-color: ${GrayColors["G-1"]};
    color: ${TextColorNames.primary};
  }
  &:hover {
    .checkmark {
      display: none;
    }
    .trash-tooltip {
      display: inline-block;
      .icon {
        color: ${GrayColors["G-2"]};
      }
    }
  }
`;

export const IconWrap = styled.span`
  padding: 0px 10px 0px 0px;
  padding-top: 3px;
`;

export const InnerIconWrap = styled.span`
  padding: 0px 0px 0px 5px;
  padding-top: 3px;
`;

export const HeaderWrap = styled.div`
  padding: 5px 5px 10px 10px;
  color: ${TextColorNames.secondary};
  font-size: 11px;
  font-weight: 500;
`;

export const FooterWrap = styled.div`
  border-top: 1px solid ${GrayColors["G-1"]};
  padding: 4px 5px 10px 5px;

  .menu-option {
    padding-left: 0;
    height: 32px;
  }
`;

export const ProviderWrap = styled.div`
  // border-top: 1px solid ${GrayColors["G-1"]};
  padding: 4px 5px;
`;

export const AddNewItem = styled.div`
  height: 32px;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  color: ${TextColorNames.tertiary};
  cursor: pointer;
  border-radius: 5px;
  transition: background 100ms ease-out;
  --select-option-is-hover-opacity: 0;
  --select-option-is-hover-background-color: ${GrayColors["G-1"]};

  &:hover,
  &.active {
    background-color: ${GrayColors["G-1"]};
    color: ${TextColorNames.primary};
  }
`;

export const PlusIconWrap = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SelectedItem = styled.div`
  height: 32px;
  display: flex;
  align-items: center;
  color: ${TextColorNames.tertiary};
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;

  svg {
    margin-right: 10px;
  }
`;

export const MenuItemWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SubMenu = styled.div`
  .sub-menu-models {
    .menu-option-wrapper__list {
      padding: 5px 0px 0px 0px;
    }
  }

  .menu-line-separator {
    margin: 11px 0 0px;
  }

  .menu-option-wrapper__list > div {
    cursor: pointer;
    &:hover {
      background: ${GrayColors["G-1"]};
    }
  }
`;

// submenu
export const Option = styled.div`
  font-size: 15px;
  display: inline-block;
  border-radius: 5px;
  padding: 4px 2px 4px 2px;
  margin: 3px 5px 3px 5px;
  svg,
  span {
    display: inline-block;
    justify-content: center;
    align-items: center;
  }

  svg {
    margin-right: 10px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;

  .support-icon {
    margin-right: 3px;
    fill: #9b9c9e;
  }

  .support-icon:hover {
    margin-right: 3px;
    fill: #4d4d4d;
  }
`;

export const SubmenuFooter = styled.div`
  background: ${GrayColors["G-0-5"]};
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: ${TextColorNames.secondary};
  padding: 10px 10px 10px 10px;
  display: flex;
  flex-direction: row;

  a {
    color: ${TextColorNames.secondary};
  }
`;
